import React, { useLayoutEffect } from 'react';
import { Navigate } from 'react-router-dom';

// Redirects a legacy/duplicate URL (e.g. /Services, /home) to its canonical target while
// marking the URL itself noindex and canonical → target, so it can never be indexed or
// prerendered as a duplicate public page.
export default function RedirectTo({ to }) {
  useLayoutEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute('content', 'noindex, follow');

    const canonicalHref = `https://ikonomakis.gr${to.split('#')[0]}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalHref);
  }, [to]);

  return <Navigate to={to} replace />;
}